
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Account} from '../core/Account';
import {FieldModelAccount} from '../core/Account';

/**
 * AccountsGetAllResult struct
 */
class AccountsGetAllResult {
  /**
   * Initialize struct
   * @param {!Array=} accounts
   * @constructor
   */
  constructor (accounts = []) {
    this.Accounts = accounts
  }

  /**
   * Copy struct (shallow copy)
   * @this {!AccountsGetAllResult}
   * @param {!AccountsGetAllResult} other Other struct
   * @returns {!AccountsGetAllResult} This struct
   */
  copy (other) {
    if (other.Accounts != null) {
      this.Accounts = []
      for (let item of other.Accounts) {
        if (item != null) {
          let tempItem
          tempItem = Account.fromObject(item)
          this.Accounts.push(tempItem)
        } else {
          this.Accounts.push(null)
        }
      }
    } else {
      this.Accounts = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!AccountsGetAllResult}
   * @returns {!AccountsGetAllResult} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new AccountsGetAllResultModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new AccountsGetAllResultModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!AccountsGetAllResult}
   * @param {!AccountsGetAllResult} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AccountsGetAllResult)) {
      throw new TypeError('Instance of AccountsGetAllResult is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!AccountsGetAllResult}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Accounts: ((this.Accounts != null) ? Array.from(this.Accounts, item => ((item != null) ? item : null)) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return AccountsGetAllResult.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!AccountsGetAllResult} other Object value
   * @returns {!AccountsGetAllResult} Created struct
   */
  static fromObject (other) {
    return new AccountsGetAllResult().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!AccountsGetAllResult}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return AccountsGetAllResult.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!AccountsGetAllResult}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 10039
  }
}

export { AccountsGetAllResult };

/**
 * Fast Binary Encoding AccountsGetAllResult field model
 */
class FieldModelAccountsGetAllResult extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Accounts = new fbe.FieldModelVector(new FieldModelAccount(buffer, 4 + 4), buffer, 4 + 4)
  }

  /**
   * Get the field size
   * @this {!FieldModelAccountsGetAllResult}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelAccountsGetAllResult}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Accounts.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelAccountsGetAllResult}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Accounts.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelAccountsGetAllResult}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelAccountsGetAllResult.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelAccountsGetAllResult}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 10039
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelAccountsGetAllResult}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelAccountsGetAllResult}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Accounts.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Accounts.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Accounts.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelAccountsGetAllResult}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelAccountsGetAllResult}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelAccountsGetAllResult}
   * @param {!AccountsGetAllResult} fbeValue Default value, defaults is new AccountsGetAllResult()
   * @returns {!AccountsGetAllResult} AccountsGetAllResult value
   */
  get (fbeValue = new AccountsGetAllResult()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelAccountsGetAllResult}
   * @param {!AccountsGetAllResult} fbeValue AccountsGetAllResult value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Accounts.fbeSize) <= fbeStructSize) {
      this.Accounts.get(fbeValue.Accounts)
    } else {
      fbeValue.Accounts.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Accounts.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelAccountsGetAllResult}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelAccountsGetAllResult}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelAccountsGetAllResult}
   * @param {!AccountsGetAllResult} fbeValue AccountsGetAllResult value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelAccountsGetAllResult}
   * @param {AccountsGetAllResult} fbeValue AccountsGetAllResult value
   */
  setFields (fbeValue) {
    this.Accounts.set(fbeValue.Accounts)
  }
}

export { FieldModelAccountsGetAllResult };

/**
 * Fast Binary Encoding AccountsGetAllResult model
 */
class AccountsGetAllResultModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelAccountsGetAllResult(this.buffer, 4)
  }

  /**
   * Get the AccountsGetAllResult model
   * @this {!AccountsGetAllResultModel}
   * @returns {!FieldModelAccountsGetAllResult} model AccountsGetAllResult model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!AccountsGetAllResultModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!AccountsGetAllResultModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return AccountsGetAllResultModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!AccountsGetAllResultModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelAccountsGetAllResult.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!AccountsGetAllResultModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!AccountsGetAllResultModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!AccountsGetAllResultModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!AccountsGetAllResultModel}
   * @param {!AccountsGetAllResult} value AccountsGetAllResult value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!AccountsGetAllResultModel}
   * @param {!AccountsGetAllResult} value AccountsGetAllResult value, defaults is new AccountsGetAllResult()
   * @return {!object} Deserialized AccountsGetAllResult value and its size
   */
  deserialize (value = new AccountsGetAllResult()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new AccountsGetAllResult(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new AccountsGetAllResult(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!AccountsGetAllResultModel}
   * @param {!number} prev Previous AccountsGetAllResult model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { AccountsGetAllResultModel };
